import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfigurationState } from './configuration.models';

// Feature selector
export const selectConfigurationState = createFeatureSelector<ConfigurationState>('configuration');

// Memoized selectors using helper functions
export const selectConfiguration = createSelector(
  selectConfigurationState,
  (state: ConfigurationState) => state
);

export const selectConfigurationCore = createSelector(
  selectConfigurationState,
  (state: ConfigurationState) => state.coreSettings
);

export const selectConfigurationLocal = createSelector(
  selectConfigurationState,
  (state: ConfigurationState) => state.localSettings
);

export const selectUSAState = createSelector(
  selectConfigurationState,
  (state: ConfigurationState) => state.usa_state
);

export const selectAllowCashPlay = createSelector(
  selectConfigurationState,
  (state: ConfigurationState) => state.allow_cash_bet
);
